import React, { useMemo } from "react";
import { Card, QueryResult, hasActiveFilters, useFilterSortPagination, } from "@sscs/ui";
import { getPageItems, getQueryStatus, sortItems } from "@sscs/utils";
import { useGetComponentIssuesQuery } from "../../services/fileBrowser.api";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import Filter from "./filter/Filter";
import styles from "./issues.module.scss";
import PolicyTable from "./policyTable/PolicyTable";
import { filterPolicies, initFilter, initSort, specialCasesForSorting, updatePolicyCategory, } from "./utils";
const preparePolicyFilters = (policies) => {
    const categories = {};
    policies.forEach((policy) => {
        updatePolicyCategory(categories, policy.id);
    });
    return categories;
};
const Issues = () => {
    const { fileId, reportId } = useGetFileAndReportId();
    const { data = { violations: [], suggestions: [] }, isLoading, isFetching, isError, error, } = useGetComponentIssuesQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const { filter, sort, pagination, handleFilterChange, handleSortChange, handlePaginationChange, } = useFilterSortPagination(initFilter, initSort);
    const categories = useMemo(() => {
        return preparePolicyFilters(data.violations);
    }, [data.violations]);
    const sortedPolicies = sortItems(data.violations
        .concat(data.suggestions)
        .filter((policy) => filterPolicies(policy, filter)), sort, specialCasesForSorting);
    const activeItems = getPageItems(sortedPolicies, pagination.currentPage, pagination.itemsPerPage);
    return (React.createElement(QueryResult, { status: getQueryStatus({
            data,
            isLoading,
            isFetching,
            isError,
            error,
        }) },
        React.createElement("div", { className: styles.container },
            React.createElement(Card.Filters, { found: {
                    id: "issues-clear-all-filters",
                    count: sortedPolicies.length,
                    initialFilters: initFilter,
                    activeFilters: filter,
                    onClear: () => handleFilterChange(initFilter),
                } },
                React.createElement(Filter, { filter: filter, categories: categories, onFilterChange: handleFilterChange })),
            React.createElement(PolicyTable, { policies: activeItems, sortBy: sort, onSortChange: handleSortChange, filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => handleFilterChange(initFilter),
                }, pagination: {
                    id: "issues-pagination",
                    itemCount: sortedPolicies.length,
                    pagination,
                    onChange: handlePaginationChange,
                    className: styles.pagination,
                } }))));
};
export default Issues;
//# sourceMappingURL=Issues.js.map